<script setup lang="ts">
import type { GyldendalSubMeaning } from "@/types/article-formats/gyldendal";

import ArticleReferences from "./ArticleReferences.vue";
import ArticleRelations from "./ArticleRelations.vue";
import ArticleTranslationGroups from "./ArticleTranslationGroups.vue";

defineProps<{
  subMeanings: GyldendalSubMeaning[];
  articleId: number;
  meaningId: number;
}>();

const getLetter = (index: number) => "abcdefghijklmnopqrstuvwxyz"[index];
const getDescription = (meaning: GyldendalSubMeaning) => {
  const description = meaning.description ?? "";
  const productiveDescription = meaning.productiveDescription ?? "";

  return [description, productiveDescription].join(" ").trim();
};
</script>

<template>
  <div :class="{ 'indentation-container': subMeanings.length > 1 }">
    <div v-for="(subMeaning, subMeaningIndex) in subMeanings" :key="subMeaningIndex">
      <span v-if="subMeanings.length > 1" class="article-list-bullet">
        {{ getLetter(subMeaningIndex) }}.
      </span>

      <div
        v-if="getDescription(subMeaning)"
        class="article-content__description"
        v-html="getDescription(subMeaning)"
      ></div>

      <ArticleTranslationGroups
        :translation-groups="subMeaning.translationGroups"
        :article-id="articleId"
        :meaning-id="meaningId"
        :sub-meaning-id="subMeaning.id"
      />

      <ArticleRelations :relations="subMeaning.relations"></ArticleRelations>

      <ArticleReferences :references="subMeaning.references" />
    </div>
  </div>
</template>
